import dayjs from "dayjs"

class ServiceOrder {
    constructor(
        id,
        taskTypeID,
        clientID,
        vehicleID,
        serviceOrderStatusID,
        technicianID,
        active,
        startDate,
        endDate,
        address,
        description
    ) {
        this.id = id
        this.taskTypeID = taskTypeID
        this.clientID = clientID
        this.vehicleID = vehicleID,
        this.serviceOrderStatusID = statusID,
        this.technicianID = technicianID,
        this.active = active,
        this.startDate = startDate,
        this.endDate = endDate,
        this.address = address,
        this.description = description
    }
}

export const serviceOrderDefault = () => {
    const serviceOrder = {
        id: 0,
        startDate: dayjs().startOf('week').format("YYYY-MM-DD"),
        endDate: dayjs().endOf('week').format("YYYY-MM-DD"),
        taskTypeID: 0,
        clientID: 0,
        vehicleID: 0,
        serviceOrderStatusID: 0,
        technicianID: 0,
        active: true,
        address: "",
        description: null
    }
    return serviceOrder
}

export default ServiceOrder